export const FLEXI_12_BROKERS_URL =
  'https://cdn.prod.website-files.com/62b040bf442187a12361b14f/66f3ff511478aa9358622554_iwoca_Flexi12_Brokers_2024-09.pdf';

export const FLEXI_12_ACCOUNTANTS_URL =
  'https://cdn.prod.website-files.com/62b040bf442187a12361b14f/66f3ff222443060518566996_iwoca_Flexi12_Accountants_2024-09.pdf';

export const FLEXI_LOAN_DE_URL =
  'https://cdn.prod.website-files.com/62e9302315b6e0c45f706ad7/6788ddb3319a037bbba50142_Produktmerkblatt_Broker_20250114.pdf';

export const FLEXI_24_BROKERS_URL =
  'https://cdn.prod.website-files.com/62b040bf442187a12361b14f/66f3ff2e75dfeff607641aa1_iwoca_Flexi24_Brokers_2024-09.pdf';

export const FLEXI_24_ACCOUNTANTS_URL =
  'https://cdn.prod.website-files.com/62b040bf442187a12361b14f/66f3e15e1c51d8e744c4c7d5_iwoca_Flexi24_Accountants_2024-09.pdf';

export const INTERST_ONLY_BROKERS_URL =
  'https://cdn.prod.website-files.com/62b040bf442187a12361b14f/66f3ff436384b2b005684ca8_iwoca_InterestOnly_Brokers_2024-09.pdf';

export const FLEXI_60_BROKERS_URL =
  'https://cdn.prod.website-files.com/62b040bf442187a12361b14f/66f3ff39bdcebc3db3a93401_iwoca_Flexi60_Brokers_2024-09.pdf';

export const FLEXI_60_ACCOUNTANTS_URL =
  'https://cdn.prod.website-files.com/62b040bf442187a12361b14f/66f3e016ede96d206f4bb175_iwoca_Flexi60_Accountants_2024-09.pdf';

export const IWOCAPAY_ACCOUNTANTS_URL =
  'https://uploads-ssl.webflow.com/62b040bf442187a12361b14f/66a35aeb9a3972788b70a904_iwoca_iwocaPay_Accountants_Mar-2023.pdf';

export const IWOCAPAY_BROKERS_URL =
  'https://static.iwoca.com/pdf/iwoca_iwocaPay_Brokers_Mar-2023.pdf';
